import React from 'react';
import AceEditor from 'react-ace';
import './editor.css'

import "ace-builds/src-noconflict/mode-pascal";
import "ace-builds/src-noconflict/theme-tomorrow_night";

import { useDispatch, useSelector } from 'react-redux';
import { updateCode } from '../../store/modules/code/action';

export default function (){

    const dispatch = useDispatch();
    const result = useSelector( state => state.code.content.code)

    function onChange(newValue) {
        dispatch( updateCode( newValue ));
        console.log(result);
      }
    
    const initial_state = ' unit Unit1;\r\n \r\ninterface\r\n\r\nuses\r\n  Windows, Messages, SysUtils, Variants, Classes, Graphics, Controls, Forms,\r\n  Dialogs, StdCtrls;\r\n\r\ntype\r\n  TForm1 = class(TForm)\r\n    //Enter first code below...\r\n    \r\n    Button1: TButton;\r\n    procedure Button1Click(Sender: TObject);\r\n  private\r\n    { private declarations }\r\n  public\r\n    { public declarations }\r\n  end;\r\n\r\nvar\r\n  Form1: TForm1;\r\n\r\nimplementation\r\n\r\n{$R *.dfm}\r\n\r\n\r\nprocedure TForm1.Button1Click(Sender: TObject);\r\nbegin\r\n    // Enter second code below\r\n    \r\nend;\r\n\r\nend.'

    return(
        <AceEditor
            className='editor'
            mode='pascal'
            theme='tomorrow_night'
            onChange={ onChange }
            defaultValue= { initial_state }
            editorProps={{ $blockScrolling: true }}
            setOptions={{
                enableBasicAutocompletion: true,
                enableLiveAutocompletion: true,
                enableSnippets: true
            }}
        />
    )
}